import { useNavigation } from "@react-navigation/native";
import React from "react";
import { LanguageContext } from "../common/language";
import { getScenePath } from "../common/scene";
import ListItem from "./ListItem";
import { formatTimestamp, UNKNOWN_LABEL } from "../common/util";
import { SheetDisplayData } from "../data/sheet";
import { View } from "react-native";
import { Chip, Text } from "react-native-paper";
import FixtureLabel from "@atgof-common/FixtureLabel";
import { SubjectSpec } from "@atgof-common/subject";
import ErrorBoundary from "./ErrorBoundary";

export default function SheetListEntry({
  sheet,
  withoutSubject,
  withCategory,
  withMetadata,
}: {
  sheet: SheetDisplayData;
  withoutSubject?: boolean;
  withCategory: boolean;
  withMetadata?: boolean;
}) {
  const { navigate } = useNavigation();
  const { ph } = React.useContext(LanguageContext);
  const character = // TODO Remove this, and just use sheet.character when enough users have stopped using bad version
    sheet.character &&
    typeof sheet.character === "object" &&
    "subjectName" in sheet.character
      ? (sheet.character as any as SubjectSpec).subjectName
      : sheet.character;
  const subject = !withoutSubject && (character || sheet.set);
  const { season, episode, scene } = getScenePath(sheet.scene || sheet.episode);
  const subjectLabel = subject ?? sheet.paSlate;
  const sceneOrEpisodeLabel =
    episode !== undefined && scene === undefined
      ? ph("ep") + " " + episode
      : (episode || UNKNOWN_LABEL) + "/" + (scene || UNKNOWN_LABEL);
  const seasonLabel = ph("season") + " " + (season || UNKNOWN_LABEL);
  return (
    <ErrorBoundary>
      <ListItem onPress={() => navigate("sheet", { path: sheet.path })}>
        <View style={{ flexDirection: "row", gap: 10 }}>
          <View style={{ alignSelf: "flex-start", paddingRight: 10 }}>
            <Text variant="headlineSmall">{sceneOrEpisodeLabel}</Text>
            <Text variant="bodySmall">{seasonLabel.toLocaleUpperCase()}</Text>
          </View>
          <View style={{ gap: 4 }}>
            <View style={{ flexDirection: "row", gap: 10 }}>
              {subjectLabel && <Text variant="titleLarge">{subjectLabel}</Text>}
              {sheet.look && (
                <Chip mode="outlined">
                  {(ph(sheet.look) as string).toLocaleUpperCase()}
                </Chip>
              )}
              {withCategory && <Chip>{ph(sheet.category) as string}</Chip>}
            </View>
            {withMetadata && (
              <Text>{formatTimestamp(sheet.createdAt, true)}</Text>
            )}
            {sheet.descriptions.map((desc) => (
              <View
                key={desc.key}
                style={{ flexDirection: "row", gap: 8, alignItems: "center" }}
              >
                {"labelSuffix" in desc && desc.labelSuffix ? (
                  <FixtureLabel
                    text={desc.labelSuffix.toLocaleUpperCase()}
                    small
                  />
                ) : null}
                <Text variant="bodyLarge">{desc.value}</Text>
              </View>
            ))}
          </View>
        </View>
      </ListItem>
    </ErrorBoundary>
  );
}
